const cardCSS = {
  'font-family': `__Open_Sans_a5ed60, __Open_Sans_Fallback_a5ed60, ui-sans-serif, system-ui, -apple-system, "system-ui", "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"`,
  color: 'white',
}

const card_number_CSS = {
  'font-size': '1.7rem',
}

const card_detail_CSS = {
  'font-size': '1.3rem',
  'line-height': '1rem',
}

export const card_number_styles = {
  ...cardCSS,
  ...card_number_CSS,
}

export const exp_date_styles = {
  ...cardCSS,
  ...card_detail_CSS,
}

export const cvv_styles = {
  ...cardCSS,
  ...card_detail_CSS,
}
